import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Parameter } from '../../../services/parameter.service';

@Component({
    selector: 'app-delete-parameter-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    templateUrl: './delete-parameter-dialog.component.html',
    styleUrl: './delete-parameter-dialog.component.scss'
})
export class DeleteParameterDialogComponent {
    constructor(
        // eslint-disable-next-line no-unused-vars
        public dialogRef: MatDialogRef<DeleteParameterDialogComponent>,
        // eslint-disable-next-line no-unused-vars
        @Inject(MAT_DIALOG_DATA) public data: { parameter: Parameter }
    ) {}

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}

